const fold = 'linear-gradient(180.36deg, #535353 0.31%, #272727 99.69%), #898989';
const call = 'linear-gradient(180.36deg, #70A74A 0.31%, #4B7B27 99.69%), #58B00F';
const raise = 'linear-gradient(180deg, #A54644 0%, #6D1710 100%), linear-gradient(180deg, #A24442 0%, #701A13 100%)';
const check = 'linear-gradient(180.36deg, #70A74A 0.31%, #4B7B27 99.69%), #58B00F';

// eslint-disable-next-line import/prefer-default-export
export const positionSelectorGroupedOptions = [
  // {
  //   label: '',
  //   options: [
  //     {
  //       label: 'RANDOM',
  //       value: 'random',
  //       controls: [
  //         {
  //           name: 'FOLD',
  // eslint-disable-next-line max-len
  //           customBackground: fold,
  //         },
  //         {
  //           name: 'CALL',
  // eslint-disable-next-line max-len
  //           customBackground: call,
  //         },
  //         {
  //           name: 'RAISE',
  // eslint-disable-next-line max-len
  //           customBackground: raise,
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    label: 'RFI',
    options: [
      {
        type: 'RFI',
        label: 'Random RFI',
        value: 'randomRfi',
        subValue: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'RFI',
        label: 'Random RFI(no blinds)',
        value: 'randomRfiNoBlinds',
        subValue: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'RFI',
        label: 'EP',
        value: 'ep',
        subValue: 'ep',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'RFI',
        label: 'MP',
        value: 'mp',
        subValue: 'mp',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'RFI',
        label: 'CO',
        value: 'co',
        subValue: 'co',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'RFI',
        label: 'BU',
        value: 'bu',
        subValue: 'bu',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'RFI',
        label: 'SB',
        value: 'sb',
        subValue: 'sb',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'RFI',
        label: 'SB no limp',
        value: 'sbnolimp',
        subValue: 'sbnolimp',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'RFI',
        label: 'BB vs SB limp',
        value: 'bbvssblimp',
        subValue: 'bbvssblimp',
        opponent: 'sb',
        controls: [
          {
            name: 'CHECK',
            customBackground: check,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
    ],
  },
  {
    label: 'easyrfi',
    options: [
      {
        type: 'easyrfi',
        label: 'Random RFI',
        value: 'randomRfi',
        subValue: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'easyrfi',
        label: 'Random RFI(no blinds)',
        value: 'randomRfiNoBlinds',
        subValue: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'easyrfi',
        label: 'EP',
        value: 'ep',
        subValue: 'ep',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'easyrfi',
        label: 'MP',
        value: 'mp',
        subValue: 'mp',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'easyrfi',
        label: 'CO',
        value: 'co',
        subValue: 'co',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'easyrfi',
        label: 'BU',
        value: 'bu',
        subValue: 'bu',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'easyrfi',
        label: 'SB',
        value: 'sb',
        subValue: 'sb',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'easyrfi',
        label: 'SB no limp',
        value: 'sbnolimp',
        subValue: 'sbnolimp',
        // opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
    ],
  },
  {
    label: 'CC/3bet',
    options: [
      {
        type: 'CC/3bet',
        label: 'Random CC/3bet',
        value: 'randomCC3Bet',
        subValue: 'mpvsep',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'CC/3bet',
        label: 'MP vs EP',
        value: 'mpvsep',
        subValue: 'mpvsep',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'CO vs EP',
        value: 'covsep',
        subValue: 'covsep',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'BU vs EP',
        value: 'buvsep',
        subValue: 'buvsep',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'SB vs EP',
        value: 'sbvsep',
        subValue: 'sbvsep',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'BB vs EP',
        value: 'bbvsep',
        subValue: 'bbvsep',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'CC/3bet',
        label: 'CO vs MP',
        value: 'covsmp',
        subValue: 'covsmp',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'BU vs MP',
        value: 'buvsmp',
        subValue: 'buvsmp',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'SB vs MP',
        value: 'sbvsmp',
        subValue: 'sbvsmp',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'BB vs MP',
        value: 'bbvsmp',
        subValue: 'bbvsmp',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'CC/3bet',
        label: 'BU vs CO',
        value: 'buvsco',
        subValue: 'buvsco',
        opponent: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'SB vs CO',
        value: 'sbvsco',
        subValue: 'sbvsco',
        opponent: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'BB vs CO',
        value: 'bbvsco',
        subValue: 'bbvsco',
        opponent: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'CC/3bet',
        label: 'SB vs BU',
        value: 'sbvsbu',
        subValue: 'sbvsbu',
        opponent: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'BB vs BU',
        value: 'bbvsbu',
        subValue: 'bbvsbu',
        opponent: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'CC/3bet',
        label: 'BB vs SB',
        value: 'bbvssb',
        subValue: 'bbvssb',
        opponent: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'CC/3bet',
        label: 'BB vs SB no limp',
        value: 'bbvssbnolimp',
        subValue: 'bbvssbnolimp',
        opponent: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'CC/3bet',
        label: 'SB limp vs BB raise',
        value: 'sblimpvsbb',
        subValue: 'sblimpvsbb',
        opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
    ],
  },
  {
    label: 'vs 3bet',
    options: [
      {
        type: 'vs 3bet',
        label: 'Random vs 3bet',
        value: 'randomVs3Bet',
        subValue: 'epvsmp',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 3bet',
        label: 'EP vs MP',
        value: 'epvsmp',
        subValue: 'epvsmp',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'EP vs CO',
        value: 'epvsco',
        subValue: 'epvsco',
        opponent: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'EP vs BU',
        value: 'epvsbu',
        subValue: 'epvsbu',
        opponent: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'EP vs SB',
        value: 'epvssb',
        subValue: 'epvssb',
        opponent: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'EP vs BB',
        value: 'epvsbb',
        subValue: 'epvsbb',
        opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 3bet',
        label: 'MP vs CO',
        value: 'mpvsco',
        subValue: 'mpvsco',
        opponent: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'MP vs BU',
        value: 'mpvsbu',
        subValue: 'mpvsbu',
        opponent: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'MP vs SB',
        value: 'mpvssb',
        subValue: 'mpvssb',
        opponent: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'MP vs BB',
        value: 'mpvsbb',
        subValue: 'mpvsbb',
        opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'CO vs BU',
        value: 'covsbu',
        subValue: 'covsbu',
        opponent: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'CO vs SB',
        value: 'covssb',
        subValue: 'covssb',
        opponent: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'CO vs BB',
        value: 'covsbb',
        subValue: 'covsbb',
        opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 3bet',
        label: 'BU vs SB',
        value: 'buvssb',
        subValue: 'buvssb',
        opponent: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'BU vs BB',
        value: 'buvsbb',
        subValue: 'buvsbb',
        opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 3bet',
        label: 'SB vs BB',
        value: 'sbvsbb',
        subValue: 'sbvsbb',
        opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 3bet',
        label: 'SB no limp vs BB',
        value: 'sbnolimpvsbb',
        subValue: 'sbnolimpvsbb',
        opponent: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
    ],
  },
  {
    label: 'VS SQZ',
    options: [
      {
        type: 'VS SQZ',
        label: 'Random VS SQZ',
        value: 'randomVsSqz',
        subValue: 'epvssqzmp+co',
        opponent: 'mp',
        opponent2: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'VS SQZ',
        label: 'EP vs MP+SB sqz',
        value: 'epvssqzmp+sb',
        subValue: 'epvssqzmp+sb',
        opponent: 'mp',
        opponent2: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'VS SQZ',
        label: 'EP vs MP+CO sqz',
        value: 'epvssqzmp+co',
        subValue: 'epvssqzmp+co',
        opponent: 'mp',
        opponent2: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'VS SQZ',
        label: 'EP vs CO+BU sqz',
        value: 'epvssqzco+bu',
        subValue: 'epvssqzco+bu',
        opponent: 'co',
        opponent2: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'VS SQZ',
        label: 'EP vs BU+SB sqz',
        value: 'epvssqzbu+sb',
        subValue: 'epvssqzbu+sb',
        opponent: 'bu',
        opponent2: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'VS SQZ',
        label: 'EP vs SB+BB sqz',
        value: 'epvssqzsb+bb',
        subValue: 'epvssqzsb+bb',
        opponent: 'sb',
        opponent2: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'VS SQZ',
        label: 'MP vs CO+SB sqz',
        value: 'mpvssqzco+sb',
        subValue: 'mpvssqzco+sb',
        opponent: 'co',
        opponent2: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'VS SQZ',
        label: 'MP vs CO+BU sqz',
        value: 'mpvssqzco+bu',
        subValue: 'mpvssqzco+bu',
        opponent: 'co',
        opponent2: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'VS SQZ',
        label: 'MP vs BU+SB sqz',
        value: 'mpvssqzbu+sb',
        subValue: 'mpvssqzbu+sb',
        opponent: 'bu',
        opponent2: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'VS SQZ',
        label: 'MP vs SB+BB sqz',
        value: 'mpvssqzsb+bb',
        subValue: 'mpvssqzsb+bb',
        opponent: 'sb',
        opponent2: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'VS SQZ',
        label: 'CO vs BU+SB sqz',
        value: 'covssqzbu+sb',
        subValue: 'covssqzbu+sb',
        opponent: 'bu',
        opponent2: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'VS SQZ',
        label: 'CO vs SB+BB sqz',
        value: 'covssqzsb+bb',
        subValue: 'covssqzsb+bb',
        opponent: 'sb',
        opponent2: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'VS SQZ',
        label: 'BU vs SB+BB sqz',
        value: 'buvssqzsb+bb',
        subValue: 'buvssqzsb+bb',
        opponent: 'sb',
        opponent2: 'bb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
    ],
  },
  {
    label: 'SQZ',
    options: [
      {
        type: 'SQZ',
        label: 'Random SQZ',
        value: 'randomSqz',
        subValue: 'cosqzep+mp',
        opponent: 'ep',
        opponent2: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'SQZ',
        label: 'CO sqz EP+MP',
        value: 'cosqzep+mp',
        subValue: 'cosqzep+mp',
        opponent: 'ep',
        opponent2: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'SQZ',
        label: 'BU sqz EP+MP',
        value: 'busqzep+mp',
        subValue: 'busqzep+mp',
        opponent: 'ep',
        opponent2: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'SQZ',
        label: 'BU sqz MP+CO',
        value: 'busqzmp+co',
        subValue: 'busqzmp+co',
        opponent: 'mp',
        opponent2: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'SQZ',
        label: 'SB sqz EP+MP',
        value: 'sbsqzep+mp',
        subValue: 'sbsqzep+mp',
        opponent: 'ep',
        opponent2: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'SQZ',
        label: 'SB sqz MP+CO',
        value: 'sbsqzmp+co',
        subValue: 'sbsqzmp+co',
        opponent: 'mp',
        opponent2: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'SQZ',
        label: 'SB sqz CO+BU',
        value: 'sbsqzco+bu',
        subValue: 'sbsqzco+bu',
        opponent: 'co',
        opponent2: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'SQZ',
        label: 'BB sqz EP+MP',
        value: 'bbsqzep+mp',
        subValue: 'bbsqzep+mp',
        opponent: 'ep',
        opponent2: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'SQZ',
        label: 'BB sqz MP+CO',
        value: 'bbsqzmp+co',
        subValue: 'bbsqzmp+co',
        opponent: 'mp',
        opponent2: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'SQZ',
        label: 'BB sqz CO+BU',
        value: 'bbsqzco+bu',
        subValue: 'bbsqzco+bu',
        opponent: 'co',
        opponent2: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'SQZ',
        label: 'BB sqz BU+SB',
        value: 'bbsqzbu+sb',
        subValue: 'bbsqzbu+sb',
        opponent: 'bu',
        opponent2: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
    ],
  },
  {
    label: '4BET',
    options: [
      {
        type: '4BET',
        label: 'Random 4BET',
        value: 'random4Bet',
        subValue: 'sb4bvsep+mp3bet',
        opponent: 'ep',
        opponent2: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: '4BET',
        label: 'CO4B vs EP+MP3BET',
        value: 'co4bvsep+mp3bet',
        subValue: 'co4bvsep+mp3bet',
        opponent: 'ep',
        opponent2: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: '4BET',
        label: 'BU4B vs MP+CO3BET',
        value: 'bu4bvsmp+co3bet',
        subValue: 'bu4bvsmp+co3bet',
        opponent: 'mp',
        opponent2: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: '4BET',
        label: 'SB4B vs EP+MP3BET',
        value: 'sb4bvsep+mp3bet',
        subValue: 'sb4bvsep+mp3bet',
        opponent: 'ep',
        opponent2: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: '4BET',
        label: 'SB4B vs CO+BU3BET',
        value: 'sb4bvsco+bu3bet',
        subValue: 'sb4bvsco+bu3bet',
        opponent: 'co',
        opponent2: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: '4BET',
        label: 'BB4B vs BU+SB3BET',
        value: 'bb4bvsbu+sb3bet',
        subValue: 'bb4bvsbu+sb3bet',
        opponent: 'bu',
        opponent2: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
    ],
  },
  {
    label: 'vs 4bet',
    options: [
      {
        type: 'vs 4bet',
        label: 'Random vs 4bet',
        value: 'randomvs4bet',
        subValue: 'randomvs4bet',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 4bet',
        label: 'MP vs EP',
        value: 'mpvsep4bet',
        subValue: 'mpvsep4bet',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 4bet',
        label: 'CO vs EP',
        value: 'covsep4bet',
        subValue: 'covsep4bet',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'CO vs MP',
        value: 'covsmp4bet',
        subValue: 'covsmp4bet',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 4bet',
        label: 'BU vs EP',
        value: 'buvsep4bet',
        subValue: 'buvsep4bet',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'BU vs MP',
        value: 'buvsmp4bet',
        subValue: 'buvsmp4bet',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'BU vs CO',
        value: 'buvsco4bet',
        subValue: 'buvsco4bet',
        opponent: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 4bet',
        label: 'SB vs EP',
        value: 'sbvsep4bet',
        subValue: 'sbvsep4bet',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'SB vs MP',
        value: 'sbvsmp4bet',
        subValue: 'sbvsmp4bet',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'SB vs CO',
        value: 'sbvsco4bet',
        subValue: 'sbvsco4bet',
        opponent: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'SB vs BU',
        value: 'sbvsbu4bet',
        subValue: 'sbvsbu4bet',
        opponent: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        label: 'Del',
        value: 'del',
      },
      {
        type: 'vs 4bet',
        label: 'BB vs EP',
        value: 'bbvsep4bet',
        subValue: 'bbvsep4bet',
        opponent: 'ep',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'BB vs MP',
        value: 'bbvsmp4bet',
        subValue: 'bbvsmp4bet',
        opponent: 'mp',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'BB vs CO',
        value: 'bbvsco4bet',
        subValue: 'bbvsco4bet',
        opponent: 'co',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'BB vs BU',
        value: 'bbvsbu4bet',
        subValue: 'bbvsbu4bet',
        opponent: 'bu',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'BB vs SB',
        value: 'bbvssb4bet',
        subValue: 'bbvssb4bet',
        opponent: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
      {
        type: 'vs 4bet',
        label: 'BB vs SB no limp',
        value: 'bbvssbnolimp4bet',
        subValue: 'bbvssbnolimp4bet',
        opponent: 'sb',
        controls: [
          {
            name: 'FOLD',
            customBackground: fold,
          },
          {
            name: 'CALL',
            customBackground: call,
          },
          {
            name: 'RAISE',
            customBackground: raise,
          },
        ],
      },
    ],
  },
];
